import React, { useContext, useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import JoditEditor from "jodit-react";

import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import Select from "react-select";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import classNames from "classnames";
import { getData } from "../../../utils/api";
import { IDS, ItemType, SelectImageData, Types } from "../../../utils/common";

library.add(fas);

// const AddOffCanvance = (props) => {
const AddOffCanvance = ({
  defaultTypeId,
  hideType = false,
  onSuccess,
  ...props
}) => {
  const { postData, IMG_URL, getDimension, Select2Data } = useContext(Context);

  const [showModal, setShowModal] = useState({ code: 0, message: "" });
  const [countries, setCountries] = useState([]);
  const [frametype, setFrametype] = useState([]);
  const [calculation, setCalculation] = useState([]);
  const [calculationdetail, setCalculationdetail] = useState([]);

  // Fetch master data
  const GetAllType = async () => {
    const response = await getData("/common/masters/all-type");
    if (response?.success) {
      setCountries(await Select2Data(response?.data, "type_id"));
    }
  };

  const GetAllFrameType = async () => {
    const response = await getData("/common/masters/all-frame-type");
    if (response?.success) {
      setFrametype(await Select2Data(response?.data, "frame_type_id"));
    }
  };

  const GetAllCalculationDetail = async () => {
    const response = await getData("/common/masters/all-calculation");
    if (response?.success) {
      setCalculationdetail(await response?.data);
    }
  };

  const GetAllCalculation = async () => {
    const response = await getData("/common/masters/all-calculation");
    if (response?.success) {
      setCalculation(await Select2Data(response?.data, "calculation_id"));
    }
  };

  const [mirrorExists, setMirrorExists] = useState(false);

  const checkMirrorExists = async () => {
    const response = await getData("/admin/masters/p-sub-type/mirror-exists");
    console.log(response, "responseresponse");

    if (response?.success) {
      setMirrorExists(response.data.exists);
    }
  };

  useEffect(() => {
    GetAllType();
    GetAllFrameType();
    GetAllCalculation();
    GetAllCalculationDetail();
    checkMirrorExists();
  }, []);

  useEffect(() => {
    if (defaultTypeId && countries.length) {
      const selected = countries.find(
        (item) => Number(item.value) === Number(defaultTypeId),
      );

      if (selected) {
        setValue("type_id", selected);
      }
    }
  }, [countries, defaultTypeId]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    control,
    setValue,
    watch,
    trigger,
  } = useForm();

  const selectedType = watch("type_id");
  const typeValue = Number(selectedType?.value);
  const selectedCalculation = watch("calculation_id");
  const minThickness = watch("min_thickness");
  const maxThickness = watch("max_thickness");
  const selectedWrapType = watch("wrap_type");

  const filteredCalculations =
    typeValue === 1
      ? calculation.filter((item) => item.value === 1)
      : calculation.filter((item) => item.value !== 1);
  // Dynamic required logic
  const isRequired = (field) => {
    if (!typeValue) return false;

    const commonFields = [
      "type_id",
      "calculation_id",
      "name",
      "per_sq_ft_price",
    ];

    if (commonFields.includes(field)) return true;

    switch (typeValue) {
      case Types?.FrameSize:
        return ["length", "width"].includes(field);

      case Types?.FrameMaterial:
        return ["frame_type_id", "image", "border_image"].includes(field);

      case Types?.MountType:
        return ["min_thickness", "max_thickness", "count"].includes(field);

      case Types?.GlassDetail:
      case Types?.Printing:
      case Types?.PrintingOptional:
        return ["description"].includes(field);

      case Types?.SelectSlides:
        return ["description", "colour", "wrap_type"].includes(field);

      case Types?.SelectThickness:
        return ["description", "max_thickness"].includes(field);

      default:
        return false;
    }
  };

  // Trigger validation when type changes
  useEffect(() => {
    if (typeValue) {
      trigger(); // Re-validate all fields
    }
  }, [typeValue, trigger]);

  useEffect(() => {
    if (!typeValue) return;

    if (typeValue === 1) {
      const calculationOne = calculation.find((item) => item.value === 1);

      if (calculationOne) {
        setValue("calculation_id", calculationOne);
      }
    } else {
      const selectedValue = watch("calculation_id")?.value;

      if (selectedValue === 1) {
        setValue("calculation_id", null);
      }
    }
  }, [typeValue, calculation, setValue]);

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("type_id", data?.type_id?.value);
      if (data?.frame_type_id?.value) {
        sendData.append("frame_type_id", data.frame_type_id.value);
      }
      sendData.append("calculation_id", data?.calculation_id?.value);
      sendData.append("name", data?.name);
      sendData.append("alt_tag", data?.alt_tag || "");
      sendData.append("border_image_alt_tag", data?.border_image_alt_tag || "");
      if (data?.length) {
        sendData.append("length", data?.length);
      }
      if (data?.width) {
        sendData.append("width", data?.width);
      }

      if (data?.per_sq_ft_price) {
        sendData.append("per_sq_ft_price", data?.per_sq_ft_price);
      }

      if (data?.description) {
        sendData.append("description", data?.description || "");
      }
      if (data?.min_thickness) {
        sendData.append("min_thickness", data?.min_thickness);
      }

      // if (typeValue === Types.MountType) {
      if (data?.max_thickness) {
        sendData.append("max_thickness", data?.max_thickness);
      }
      if (data?.count) {
        sendData.append("count", data?.count ?? null);
      }

      if (data?.colour) {
        sendData.append("colour", data.colour);
      }

      if (data?.wrap_type) {
        sendData.append("wrap_type", data.wrap_type.value);
      }

      if (data?.image?.[0]) sendData.append("image", data.image[0]);
      if (data?.border_image?.[0])
        sendData.append("border_image", data.border_image[0]);

      const response = await postData(`/admin/masters/p-sub-type`, sendData);

      if (response?.success) {
        setShowModal({ code: response.code, message: response.message });
      } else {
        setShowModal({
          code: response?.code || 400,
          message:
            response?.errors?.parent?.sqlMessage ||
            response?.errors?.message ||
            "Error occurred",
        });
      }

      setTimeout(() => {
        setShowModal({ code: 0, message: "" });
        if (onSuccess) {
          onSuccess();
        }
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  // Image Preview Handlers
  const [imagePreview, setImagePreview] = useState(null);
  const [borderImagePreview, setBorderImagePreview] = useState(null);

  const handleImageChange = (e) => {
    const file = e?.target?.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleBorderImageChange = (e) => {
    const file = e?.target?.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setBorderImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  // Gallery Images (if needed)
  const [GalleryImages, setGalleryImages] = useState([]);
  const getGalleyImages = async () => {
    try {
      const response = await getData("/common/masters/all-gallery-images");
      if (response?.data) {
        setGalleryImages(await SelectImageData(response.data, "image"));
      }
    } catch (error) {
      console.error("Error fetching gallery images:", error);
    }
  };

  useEffect(() => {
    getGalleyImages();
  }, []);

  const handleGalleryImageChange = (selectedOption) => {
    setValue("image", null);
    setValue("gallery_image", selectedOption);
    setImagePreview(IMG_URL + selectedOption?.image);
    clearErrors("image");
  };

  const handleFileInputChange = (e) => {
    setValue("gallery_image", null);
    handleImageChange(e);
    clearErrors("image");
  };

  const handleNumberKeyDown = (e, allowDecimal = false) => {
    // Allow control keys
    if (
      e.key === "Backspace" ||
      e.key === "Delete" ||
      e.key === "Tab" ||
      e.key === "ArrowLeft" ||
      e.key === "ArrowRight"
    ) {
      return;
    }

    // Allow decimal point only when explicitly enabled
    if (allowDecimal && e.key === ".") {
      // Prevent more than one decimal point
      if (e.target.value.includes(".")) {
        e.preventDefault();
      }
      return;
    }

    // Allow only digits
    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
      return;
    }

    // Prevent 0 as the first digit
    if (e.target.value === "" && e.key === "0") {
      e.preventDefault();
    }
  };

  const selectedCalculationDetail = calculationdetail?.find(
    (item) => item?.id === selectedCalculation?.value,
  );

  console.log("mirrorExists =>", mirrorExists);

  const wrapTypeOptions = [
    {
      value: false,
      label: "Colour",
    },
    ...(!mirrorExists
      ? [
          {
            value: true,
            label: "Mirror",
          },
        ]
      : []),
  ];

  return (
    <>
      <Modal {...props} onHide={props.handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Product Sub Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className="justify-content-center">
              {/* Type */}
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>
                    Type <span className="text-danger">*</span>
                  </Form.Label>
                  <Controller
                    name="type_id"
                    control={control}
                    rules={{ required: "Type is required" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        isDisabled={hideType}
                        // options={countries}
                        options={countries.map((item) => ({
                          ...item,
                          isDisabled:
                            Number(item.value) === Types.PrintingOptional ||
                            Number(item.value) === Types.Printing ||
                            Number(item.value) === Types.FrameOption,
                        }))}
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderColor: errors.type_id
                              ? "red"
                              : base.borderColor,
                          }),
                        }}
                      />
                    )}
                  />
                  {errors.type_id && (
                    <span className="text-danger">
                      {errors.type_id.message}
                    </span>
                  )}
                </div>
              </Col>

              {/* Calculation - Always Required */}
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>
                    Calculation <span className="text-danger">*</span>
                  </Form.Label>
                  <Controller
                    name="calculation_id"
                    control={control}
                    rules={{ required: "Calculation is required" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={filteredCalculations}
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderColor: errors.calculation_id
                              ? "red"
                              : base.borderColor,
                          }),
                        }}
                      />
                    )}
                  />
                  {errors.calculation_id && (
                    <span className="text-danger">
                      {errors.calculation_id.message}
                    </span>
                  )}
                  {selectedCalculationDetail?.description && (
                    <div className="mt-2">
                      <p
                        style={{
                          fontSize: "14px",
                          color: "#666",
                          marginBottom: 0,
                        }}
                      >
                        <strong>Formula:</strong>{" "}
                        {selectedCalculationDetail.description}
                      </p>
                    </div>
                  )}
                </div>
              </Col>

              {/* Frame Type - Conditional */}
              {isRequired("frame_type_id") && (
                <Col md={6}>
                  <div className="main-form-section mt-3">
                    <Form.Label>
                      Frame Type <span className="text-danger">*</span>
                    </Form.Label>
                    <Controller
                      name="frame_type_id"
                      control={control}
                      rules={{ required: "Frame Type is required" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={frametype}
                          styles={{
                            control: (base) => ({
                              ...base,
                              borderColor: errors.frame_type_id
                                ? "red"
                                : base.borderColor,
                            }),
                          }}
                        />
                      )}
                    />
                    {errors.frame_type_id && (
                      <span className="text-danger">
                        {errors.frame_type_id.message}
                      </span>
                    )}
                  </div>
                </Col>
              )}

              {/* Product Sub Type - Always Required */}
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>
                    Product Sub Type <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    {...register("name", {
                      required: "Product Sub Type is required",
                    })}
                    className={classNames({ "is-invalid": errors.name })}
                    placeholder="Sub Type"
                  />
                  {errors.name && (
                    <span className="text-danger">{errors.name.message}</span>
                  )}
                </div>
              </Col>

              {/* Length & Width - FrameSize */}
              {isRequired("length") && (
                <Col md={6}>
                  <div className="main-form-section mt-3">
                    <Form.Label>
                      Length (Inches) <span className="text-danger">*</span>
                    </Form.Label>
                    {/* <Form.Control
                      type="text"
                      {...register("length", {
                        required: "Length is required",
                      })}
                      className={classNames({ "is-invalid": errors.length })}
                      placeholder="Length"
                      onKeyDown={(e) => {
                       
                      }}
                    /> */}
                    <Form.Control
                      type="text"
                      {...register("length", {
                        required: "Length is required",
                        validate: (value) => {
                          const number = Number(value);

                          if (isNaN(number)) {
                            return "Only numbers are allowed";
                          }

                          if (number <= 0) {
                            return "Length must be greater than 0";
                          }

                          return true;
                        },
                      })}
                      className={classNames({ "is-invalid": errors.length })}
                      placeholder="Length"
                      // name="length"
                      // placeholder="Length"
                      // className={classNames({
                      //   "is-invalid": errors?.length,
                      // })}
                      // {...register("length", {
                      //   required: "Length is required",
                      // })}
                      onKeyDown={(e) => {
                        if (
                          e.key === "Backspace" ||
                          e.key === "Delete" ||
                          e.key === "Tab" ||
                          e.key === "ArrowLeft" ||
                          e.key === "ArrowRight"
                        ) {
                          return;
                        }

                        if (!/^\d$/.test(e.key)) {
                          e.preventDefault();
                          return;
                        }

                        if (e.target.value === "" && e.key === "0") {
                          e.preventDefault();
                        }
                      }}
                    />
                    {errors.length && (
                      <span className="text-danger">
                        {errors.length.message}
                      </span>
                    )}
                  </div>
                </Col>
              )}

              {isRequired("width") && (
                <Col md={6}>
                  <div className="main-form-section mt-3">
                    <Form.Label>
                      Width (Inches) <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      {...register("width", {
                        required: "Width is required",
                        validate: (value) => {
                          const number = Number(value);

                          if (isNaN(number)) {
                            return "Only numbers are allowed";
                          }

                          if (number <= 0) {
                            return "Width must be greater than 0";
                          }

                          return true;
                        },
                      })}
                      className={classNames({ "is-invalid": errors.width })}
                      placeholder="Width"
                      onKeyDown={(e) => {
                        if (
                          e.key === "Backspace" ||
                          e.key === "Delete" ||
                          e.key === "Tab" ||
                          e.key === "ArrowLeft" ||
                          e.key === "ArrowRight"
                        ) {
                          return;
                        }

                        if (!/^\d$/.test(e.key)) {
                          e.preventDefault();
                          return;
                        }

                        if (e.target.value === "" && e.key === "0") {
                          e.preventDefault();
                        }
                      }}
                    />
                    {errors.width && (
                      <span className="text-danger">
                        {errors.width.message}
                      </span>
                    )}
                  </div>
                </Col>
              )}

              {isRequired("min_thickness") && (
                <Col md={6}>
                  <Form.Label>
                    Minimum Thickness <span className="text-danger">*</span>
                  </Form.Label>

                  <Form.Control
                    type="text"
                    {...register("min_thickness", {
                      required: "Minimum Thickness is required",
                      pattern: {
                        value: /^\d+(\.\d+)?$/,
                        message: "Only valid numbers are allowed",
                      },
                      validate: (value) => {
                        if (
                          maxThickness &&
                          Number(value) > Number(maxThickness)
                        ) {
                          return "Minimum Thickness cannot be greater than Maximum Thickness";
                        }

                        return true;
                      },
                    })}
                    className={classNames({
                      "is-invalid": errors.min_thickness,
                    })}
                    onKeyDown={(e) => handleNumberKeyDown(e, true)}
                  />
                  {errors.min_thickness && (
                    <span className="text-danger">
                      {errors.min_thickness.message}
                    </span>
                  )}
                </Col>
              )}
              {isRequired("max_thickness") && (
                <Col md={6}>
                  <Form.Label>
                    Maximum Thickness <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    {...register("max_thickness", {
                      required: "Maximum Thickness is required",
                      pattern: {
                        value: /^\d+(\.\d+)?$/,
                        message: "Only valid numbers are allowed",
                      },
                      validate: (value) => {
                        if (
                          minThickness &&
                          Number(value) < Number(minThickness)
                        ) {
                          return "Maximum Thickness cannot be less than Minimum Thickness";
                        }

                        return true;
                      },
                    })}
                    className={classNames({
                      "is-invalid": errors.max_thickness,
                    })}
                    onKeyDown={(e) => handleNumberKeyDown(e, true)}
                  />
                  {errors.max_thickness && (
                    <span className="text-danger">
                      {errors.max_thickness.message}
                    </span>
                  )}
                </Col>
              )}

              {isRequired("count") && (
                <Col md={6}>
                  <Form.Label>
                    Count <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    {...register("count", {
                      required: "Count is required",
                      pattern: {
                        value: /^[0-9]+$/,
                        message: "Only numbers are allowed",
                      },
                      min: {
                        value: 0,
                        message: "Count cannot be less than 0",
                      },
                      max: {
                        value: 3,
                        message: "Count cannot be greater than 3",
                      },
                    })}
                    className={classNames({ "is-invalid": errors.count })}
                    onKeyDown={handleNumberKeyDown}
                  />

                  {errors.count && (
                    <span className="text-danger">{errors.count.message}</span>
                  )}
                </Col>
              )}
              {/* </>
              )} */}

              {/* Image & Border Image - FrameMaterial */}
              {isRequired("image") && (
                <>
                  <Col md={6}>
                    <Form.Label>
                      Image <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      {...register("image", { required: "Image is required" })}
                      onChange={handleImageChange}
                    />
                    {errors.image && (
                      <span className="text-danger">
                        {errors.image.message}
                      </span>
                    )}
                    <Form.Label className="mt-2">Alt Tag</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Alt Tag"
                      {...register("alt_tag")}
                    />
                  </Col>
                  <Col md={6}>
                    {imagePreview && (
                      <img
                        src={imagePreview}
                        alt="preview"
                        className="image-preview"
                      />
                    )}
                  </Col>

                  <Col md={6}>
                    <Form.Label>
                      Border Image <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      {...register("border_image", {
                        required: "Border Image is required",
                      })}
                      onChange={handleBorderImageChange}
                    />
                    {errors.border_image && (
                      <span className="text-danger">
                        {errors.border_image.message}
                      </span>
                    )}
                    <Form.Label className="mt-2">Border Image Alt Tag</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Border Image Alt Tag"
                      {...register("border_image_alt_tag")}
                    />
                  </Col>
                  <Col md={6}>
                    {borderImagePreview && (
                      <img
                        src={borderImagePreview}
                        alt="preview"
                        className="image-preview"
                      />
                    )}
                  </Col>
                </>
              )}

              {/* Description - Conditional */}
              {isRequired("description") && (
                <Col md={12}>
                  <Form.Label>
                    Description <span className="text-danger">*</span>
                  </Form.Label>
                  <Controller
                    name="description"
                    control={control}
                    rules={{
                      validate: (value) => {
                        const plainText = value
                          ?.replace(/<[^>]+>/g, "")
                          ?.replace(/&nbsp;/g, "")
                          ?.trim();

                        return (
                          plainText?.length > 0 || "Description is required"
                        );
                      },
                    }}
                    render={({ field }) => (
                      <JoditEditor
                        value={field.value || ""}
                        onBlur={field.onBlur}
                        onChange={(newContent) => {
                          field.onChange(newContent);
                        }}
                      />
                    )}
                  />
                  {errors.description && (
                    <span className="text-danger">
                      {errors.description.message}
                    </span>
                  )}
                </Col>
              )}

              {isRequired("wrap_type") && (
                <Col md={6}>
                  <Form.Label>
                    Wrap Type <span className="text-danger">*</span>
                  </Form.Label>

                  <Controller
                    name="wrap_type"
                    control={control}
                    rules={{
                      required: "Wrap Type is required",
                    }}
                    render={({ field }) => (
                      <Select {...field} options={wrapTypeOptions} />
                    )}
                  />

                  {errors.wrap_type && (
                    <span className="text-danger">
                      {errors.wrap_type.message}
                    </span>
                  )}
                </Col>
              )}

              {isRequired("colour") && selectedWrapType?.value === false && (
                <Col md={6}>
                  <Form.Label>
                    Colour <span className="text-danger">*</span>
                  </Form.Label>

                  <Form.Control
                    type="color"
                    {...register("colour", {
                      required:
                        selectedWrapType?.value === false
                          ? "Colour is required"
                          : false,
                    })}
                  />

                  {errors.colour && (
                    <span className="text-danger">{errors.colour.message}</span>
                  )}
                </Col>
              )}

              {/* Per Sq Ft Price - Always Required */}
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>
                    Per Sq Ft Price <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    {...register("per_sq_ft_price", {
                      required: "Per Sq Ft Price is required",
                      validate: (value) => {
                        const number = Number(value);

                        if (isNaN(number)) {
                          return "Only numbers are allowed";
                        }

                        if (number <= 0) {
                          return "Per Sq Ft Price must be greater than 0";
                        }

                        return true;
                      },
                    })}
                    className={classNames({
                      "is-invalid": errors.per_sq_ft_price,
                    })}
                    placeholder="Per Square Foot Price"
                    onKeyDown={handleNumberKeyDown}
                  />
                  {errors.per_sq_ft_price && (
                    <span className="text-danger">
                      {errors.per_sq_ft_price.message}
                    </span>
                  )}
                </div>
              </Col>

              {/* Buttons */}
              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <CancelButton name="cancel" handleClose={props.handleClose} />
                  <SaveButton
                    name="save"
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={!!showModal.code}
      />
    </>
  );
};

export default AddOffCanvance;
